module.exports = __webpack_public_path__ + "1a753c1ada135521a8a5456e88b67d6c.jpg";